// This file is part of Invenio-RDM-Records
// Copyright (C) 2020-2023 CERN.
// Copyright (C) 2020-2022 Northwestern University.
// Copyright (C) 2021 Graz University of Technology.
// Copyright (C) 2025 CSC - IT Center for science ltd.
//
// Invenio-RDM-Records is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

import React, { Component } from "react";
import PropTypes from "prop-types";

import { TextField, GroupField, FieldLabel, SelectField } from "react-invenio-forms";
import { Button, Form, Icon } from "semantic-ui-react";

import { emptyInstrument } from "./initialValues";
import { i18next } from "@translations/invenio_rdm_records/i18next";
import { ArrayField } from "../Overrides";

export class InstrumentsField extends Component {
  render() {
    const { fieldPath, label, labelIcon, required, options, showEmptyValue } =
      this.props;

    return (
      <ArrayField
        addButtonLabel={i18next.t("Add instrument")}
        defaultNewValue={emptyInstrument}
        fieldPath={fieldPath}
        helpText={i18next.t(
          "Instruments or equipment used to generate the data or results described in this resource."
        )}
        label={<FieldLabel htmlFor={fieldPath} icon={labelIcon} label={label} />}
        required={required}
        showEmptyValue={showEmptyValue}
      >
        {({ arrayHelpers, indexPath }) => {
          const fieldPathPrefix = `${fieldPath}.${indexPath}`;

          return (
            <GroupField optimized>
              <TextField
                fieldPath={`${fieldPathPrefix}.instrument_name`}
                label={i18next.t("Instrument name")}
                required
                width={6}
              />

              <TextField
                fieldPath={`${fieldPathPrefix}.identifier`}
                label={i18next.t("Identifier")}
                required
                width={6}
              />

              <SelectField
                clearable
                fieldPath={`${fieldPathPrefix}.scheme`}
                label={i18next.t("Scheme")}
                aria-label={i18next.t("Scheme")}
                optimized
                options={options.scheme}
                required
                width={4}
              />

              <Form.Field>
                <Button
                  aria-label={i18next.t("Remove field")}
                  className="close-btn"
                  icon
                  onClick={() => arrayHelpers.remove(indexPath)}
                >
                  <Icon name="close" />
                </Button>
              </Form.Field>
            </GroupField>
          );
        }}
      </ArrayField>
    );
  }
}

InstrumentsField.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelIcon: PropTypes.string,
  required: PropTypes.bool,
  options: PropTypes.object.isRequired,
  showEmptyValue: PropTypes.bool,
};

InstrumentsField.defaultProps = {
  label: i18next.t("Instruments"),
  labelIcon: "wrench",
  required: undefined,
  showEmptyValue: false,
};
